module.exports = {
  accountApi: {
    server: '',
    url: '',
  },
  qcintlWoaApi: {
    server: 'api.qcintl.woa.com',
    url: 'http://api.qcintl.woa.com',
  },
  qcintlWoaApiDev: {
    server: 'api.qcintl.woa.com',
    url: 'http://api.qcintl.woa.com',
  },
  intlApi: {
    server: 'www.tencentcloud.com',
    url: 'https://www.tencentcloud.com',
  },
  newIntlApi: {
    server: 'www.tencentcloud.com',
    url: 'https://www.tencentcloud.com',
  },
  transApi: {
    server: '9.208.69.124',
    url: 'https://9.208.69.124:8080',
  },
  opmApi: {
    server: 'qcloudintlbackend.tencentyun.com',
    url: 'http://qcloudintlbackend.tencentyun.com',
  },
  officialApi: {
    server: 'official.qcintl-portal.tencentyun.com',
    url: 'https://official.qcintl-portal.tencentyun.com',
  },
  qcintlApi: {
    server: 'api.qcintl.tencentyun.com',
    url: 'http://api.qcintl.tencentyun.com',
  },
  cmsApi: {
    server: 'cms.qcintl-portal.tencentyun.com',
    url: 'http://cms.qcintl-portal.tencentyun.com:8080',
  },
  cmsPreviewApi: {
    server: 'cms.qcintl-backend.tencentyun.com',
    url: 'http://cms.qcintl-backend.tencentyun.com:8080',
  },
  buyApi: {
    server: 'buy.intl.cloud.tencent.com',
    url: 'https://buy.intl.cloud.tencent.com/cgi/v2',
  },
  renderApi: {
    server: 'live.qcintl-portal.tencentyun.com',
    url: 'http://live.qcintl-portal.tencentyun.com/v1/portal',
  },
  expressApi: {
    server: 'news.qcintl-portal.tencentyun.com',
    url: 'http://news.qcintl-portal.tencentyun.com:8080',
  },
  mcproxyApi: {
    server: 'sg.intl.mcproxy.tencentyun.com',
    url: 'http://sg.intl.mcproxy.tencentyun.com/interface.php',
  },
   channelApi: {
    server: 'intlchannel.woa.com',
    url: 'http://intlchannel.woa.com',
  },
};